import {
  ElevationLevel,
  spacing,
  styled,
  Text,
  zIndex,
  ZIndexLevel,
} from '@thg-commerce/enterprise-theme'

export const ADAChatContainer = styled.button<{ alternateText?: boolean }>`
  ${(props) => Text('bodyText', props.alternateText ? 'alternate' : 'default')}
  display: flex;
  align-items: center;
  position: relative;
`
export const ADAChatIndicator = styled.span<{ isActive?: boolean }>`
  display: block;
  margin-left: ${spacing(1)};
  min-width: 8px;
  min-height: 8px;
  background-color: ${(props) =>
    props.isActive
      ? props.theme.colors.success.base
      : props.theme.colors.palette.greys.grey};
  border-radius: 50%;
`
export const ADAChatUnavailableMessage = styled.div`
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  border-radius: 4px;
  &::before,
  &::after {
    ${zIndex(ZIndexLevel.Lower)};
    content: '';
    transform: rotate(45deg);
    width: 16px;
    height: 16px;
    position: absolute;
    top: -8px;
    left: 20%;
    background-color: ${(props) => props.theme.colors.palette.greys.white};
  }
  &::before {
    ${ElevationLevel(1)};
  }
  &::after {
    ${zIndex(ZIndexLevel.Low)};
  }
`
export const ADAChatUnavailableMessageText = styled.div`
  ${ElevationLevel(1)};
  ${zIndex(ZIndexLevel.Low)};
  padding: ${spacing(2)};
  background-color: ${(props) => props.theme.colors.palette.greys.white};
  position: relative;
  border-radius: 4px;
`
